export const appSettings = {
  'masters_url': 'http://206.189.138.212:5001/erpx',
  'sales_url': 'http://206.189.138.212:5002/erpx',
  'procure_url': 'http://206.189.138.212:5003/erpx',
  'warehouse_url': 'http://206.189.138.212:5004/erpx',
  'logistics_url': 'http://206.189.138.212:5005/erpx',
  'ums_url': 'http://206.189.138.212:5006/erpx',
  'rm_procure_url': 'http://206.189.138.212:5007/erpx',
  'transport_url': 'http://206.189.138.212:5008/erpx',
  'production_url': 'http://206.189.138.212:5009/erpx',
  'assets_url': 'http://206.189.138.212:5010/erpx',
  'hrms_url': 'http://206.189.138.212:5011/erpx',
  'planning_url': 'http://206.189.138.212:5012/erpx',
  'dbhost': '206.189.138.212',
  'dbuser': 'ramakrishna',
  'dbpassword': 'R@ms1905',
  'masters_db': 'erpx_dev_masters',
  'sales_db': 'erpx_dev_sales',
  'procure_db': 'erpx_dev_procurement',
  'warehouse_db': 'erpx_dev_warehouse',
  'logistics_db': 'erpx_dev_logistics',
  'ums_db': 'erpx_dev_ums',
  'rm_procure_db': 'erpx_dev_rm_procurement',
  'transport_db': 'erpx_dev_transport',
  'production_db': 'erpx_dev_production',
  'assets_db': 'erpx_dev_assets',
  'hrms_db': 'erpx_dev_hrms',
  'planning_db': 'erpx_dev_planning',
  'masters_port': '5001',
  'sales_port': '5002',
  'procurement_port': '5003',
  'warehouse_port': '5004',
  'logistics_port': '5005',
  'ums_port': '5006',
  'rm_procurement_port': '5007',
  'transport_port': '5008',
  'production_port': '5009',
  'assets_port': '5010',
  'hrms_port': '5011',
  'planning_port': '5012',
  // 'file_upload_path': 'http://206.189.138.212/erpx/dist/apps/services/sale-service/', // live 
   'file_upload_path' : 'http://206.189.138.212/erpx_dev/dist/apps/services/', // dev instance
  // 'logistics_doc_upload_path': 'http://206.189.138.212/erpx/dist/apps/services/logistics/', // live 
   'logistics_doc_upload_path' : 'http://206.189.138.212/erpx_dev/dist/apps/services/logistics/', // dev instance
  // 'brand_file_path': 'http://206.189.138.212/erpx/dist/apps/services/masters/', // live
   'brand_file_path': 'http://206.189.138.212/erpx_dev/dist/apps/services/masters/', // dev instance

   'whatsapp_notification_url': 'http://206.189.138.212:3000'
}

export default appSettings;